<template>
  <div>
    <modal-vue>
      <div slot="header" class="row">
        <h3>Corrigindo: &nbsp; {{quizParam.title}}</h3>
      </div>

      <div slot="body" style="margin:0px;" v-if="discursiveQuestions.length > 0">
        <div class="exam-question" style="display: block;">
          <span class="exam-question-title">
            <p style="font-size: 14px;">
              <span
                style="color:rgb(52, 58, 64); font-family:open sans,helvetica neue,helvetica,arial,sans-serif; font-size:14px"
              >{{discursiveQuestions[questionIndex].text}}</span>
            </p>
          </span>
          <div class="exam-anwser-options" :key="answerListKey" v-if="answers.length > 0">
            <textarea
              v-model="answers[answerIndex].text"
              style="width:100%; margin-top: 10px"
              rows="5"
              class="input-large"
              :disabled="true"
              maxlength="3000"
            ></textarea>
          </div>
          <div v-else>
            <span>Essa questão não possui respostas pendentes de correção</span>
          </div>

          <div slot="footer" v-if="answers.length > 0">
            <lms-button

              @click="previousAnswer()"
              :loading="savingQuiz"
            >Resposta Anterior</lms-button>
            <lms-button
              style="margin-left: 50px !important;"
              :disabled="!(discursiveQuestions.length - 1 > answerIndex)"
              @click="nextAnswer()"
              :loading="savingQuiz"
            >Próxima Resposta</lms-button>
            <br />
            <br />
            <button @click="checkAnswer(false)" class="btn btn-danger">
              Marcar como ERRADA
              <i class="fa fa-warning"></i>
            </button>
            <button
              style="margin-left: 50px !important;"
              @click="checkAnswer(true)"
              class="btn btn-success"
            >
              Marcar como CERTA
              <i class="fa fa-check"></i>
            </button>
          </div>

          <!-- PEGAR A LISTA DE ANSWERS QUE TEM ISCORRECT NULL E IDUSER, QUE SEJAM DESDE QUIZ -->
        </div>
      </div>
      <div v-else slot="body" style="margin:0px;">
        <span>Carregando...</span>
      </div>

      <div slot="footer">
        <button style="float: left;" class="btn btn-danger" v-on:click="close()">Cancelar</button>
        <lms-button
          :disabled="!(0 < questionIndex)"
          @click="previousQuestion()"
          :loading="savingQuiz"
        >Questão Anterior</lms-button>
        <lms-button
          :disabled="!(discursiveQuestions.length - 1 > questionIndex)"
          @click="nextQuestion()"
          :loading="savingQuiz"
        >Próxima Questão</lms-button>
      </div>
    </modal-vue>
  </div>
</template>


<style lang="scss" scoped>
.correct {
  background: #14247A !important;
}
.custom-grid-modal-2 {
  grid-template-columns: 0.3fr 0.3fr 1.5fr 0.3fr !important;
}

.custom-grid-modal {
  grid-template-columns: 0.3fr 1fr 0.3fr 0.3fr 0.3fr !important;
}

.li-custom {
  grid-template-columns: 0.75fr 0.75fr 0.75fr 1fr 1fr 0.75fr !important;
}

a.disabled {
  pointer-events: none;
  cursor: default;
}
</style>


<script>
import axios from "axios";
import { mapState } from "vuex";

export default {
  props: ["quizParam"],
  data() {
    return {
      answerCount: 0,
      answerListKey: 0,
      selectedAnswerId: -1,
      questionIndex: 0,
      answerIndex: 0,
      savingQuiz: false,
      course: this.$store.getters.course,
      answers: [],
      moduleId: undefined,
      discursiveQuestions: []
    };
  },
  computed: {
    ...mapState(["quiz", "questions"]),
    progressBar() {
      return (this.questionIndex * 100) / (this.questions.length - 1) + "%";
    }
  },
  methods: {
    checkAnswer(answer) {
      this.answers[this.answerIndex].isCorrect = answer;
      console.log(this.answers);
      console.log("vou checar a questão: " + this.answers[this.answerIndex].id);
      //SALVAR NO BANCO no then pegar as respostas novamente

    const path = this.$global.endpoint + "/quiz/answer/update";
      axios
        .post(path, {
          answerId: this.answers[this.answerIndex].id,
          isCorrect: answer //Questões discursivas
        })
        .then(res => {
          console.log(res.data);
          this.getAnswers(this.discursiveQuestions[this.answerIndex].id);
        })
        .catch(error => {
          console.error(error);
        });


    },
    getAnswers(questionId) {
      console.log(this.quiz.id);
      const path = this.$global.endpoint + "/quiz/answer/getall";
      axios
        .post(path, {
          questionId: questionId
        })
        .then(res => {
          console.log(res.data);
          this.answers = res.data;
          this.answerIndex = 0;
          console.log(this.answers);
        })
        .catch(error => {
          console.error(error);
        });
    },
    nextQuestion() {
      console.log(this.discursiveQuestions);
      if (this.discursiveQuestions.length - 1 > this.questionIndex) {
        this.questionIndex = this.questionIndex + 1;
      }
      this.getAnswers(this.discursiveQuestions[this.questionIndex].id);
    },
    previousQuestion() {
      if (this.questionIndex > 0) {
        this.questionIndex -= 1;
      }
      this.getAnswers(this.discursiveQuestions[this.questionIndex].id);
    },
    nextAnswer() {
      console.log("proxima resposta");
      console.log(this.answerIndex);
      console.log(this.answers);
      if (this.answers.length - 1 > this.answerIndex) {
        this.answerIndex = this.answerIndex + 1;
      }
    },
    previousAnswer() {
      console.log("mandou voltar a resposta");
      console.log(this.answerIndex);
      if (this.answerIndex > 0) {
        this.answerIndex -= 1;
       console.log(this.answerIndex);
      }
    },
    close() {
      this.$emit("close");
    },

    getQuestions() {
      console.log("buscar questões");
      console.log(this.quizParam.id);
      const path = this.$global.endpoint + "/quiz/question/getall";
      axios
        .post(path, {
          quizId: this.quizParam.id,
          type: 2 //Questões discursivas
        })
        .then(res => {
          console.log(res.data);
          this.discursiveQuestions = res.data;
          this.getAnswers(this.discursiveQuestions[0].id);
        })
        .catch(error => {
          console.error(error);
        });
    }
  },
  created() {
    console.log("CHAMOU O REVIEW QUIZ");
    console.log(this.quizParam);
    if (this.quizParam) {
      console.log("CHAMOU O GET QUIZ");
      this.moduleId = this.quizParam.moduleId;
      this.getQuestions();
    } else {
      console.log("não tem quiz");
      this.quiz = {};
      this.quiz.title = "Avaliação";
    }
    // this.$store.watch(
    //   (state, getters) => getters.quiz,
    //   (newValue, oldValue) => {
    //     console.log(`Updating from ${oldValue} to ${newValue}`);

    //     this.getAnswers();
    //   }
    // );
  }
};
</script>
